.exportPopupContainer {
  display: inline-block;
  margin: inherit;
}
